<script>
import {useThemeStore} from "@js/store/ThemeStore.js";
import CallbackBigForm from "@js/components/Sections/Callback/CallbackBigForm.vue";
import CompanyGuarantees from "@js/components/Sections/InfoCards/CompanyGuarantees.vue";
import FeedbackBrandsBadge from "@js/components/Sections/Feedbacks/Components/FeedbackBrandsBadge.vue";
import Feedbacks from "@js/components/Sections/Feedbacks/Feedbacks.vue";
import FeedbacksTopComponent from "@js/components/Sections/TopComponents/FeedbacksTopComponent.vue";

export default {
    name: "FeedbackPage",
    components: {FeedbacksTopComponent, Feedbacks, FeedbackBrandsBadge, CompanyGuarantees, CallbackBigForm},
    beforeMount() {
        this.themeStore.activateLightTheme()
    },
    setup() {
        const themeStore = useThemeStore()
        themeStore.turnOffMap()

        return {themeStore}
    }
}
</script>

<template>
    <FeedbacksTopComponent/>
    <FeedbackBrandsBadge class="-mt-[42px]"/>
    <Feedbacks class="pt-20"/>
    <CompanyGuarantees/>
    <CallbackBigForm class="mt-10"/>
</template>

<style scoped lang="scss">

</style>
